import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'
import MyBusiness from '../views/MyBusiness.vue'
import Login from '../views/Login.vue'
import Signup from '../views/Signup.vue'
import User from '../views/User.vue'
import RecyclingLedger from '../views/RecyclingLedger.vue'
import Users from '../views/Users.vue'
import AppSettings from '../views/AppSettings.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import ResetPassword from '../views/ResetPassword.vue'
import VerifyEmail from '../views/VerifyEmail.vue'
import ViewsDashboard from '../views/ViewsDashboard.vue'
import Company from '../views/Company.vue'

Vue.use(VueRouter)

const routes = [
  {path: '/', component: Index, 
  children: [
    {
      name: 'Company',
      path: '/company',
      component: Company,
      meta: { requiresRole: ['Admin'] }
    },
    {
      name: 'My Business',
      path: '/my-business',
      component: MyBusiness,
      meta: { requiresRole: ['Ledger User'] }
    },
    {
      name: 'Market Dashboard',
      path: '/collection-dashboard',
      component: ViewsDashboard,
      meta: { requiresRole: ['Login User', 'PBI Report 2'] }
    },
    {
      name: 'Forecast Dashboard',
      path: '/forecast-dashboard',
      component: ViewsDashboard,
      meta: { requiresRole: ['Login User', 'PBI Report 3'] }
    },
    {
      name: 'Prices Dashboard', 
      path: '/prices-dashboard',
      component: ViewsDashboard,
      meta: { requiresRole: ['Login User', 'PBI Report 4'] }
    },
    {
      name: 'Treatment', 
      path: '/treatment-dashboard',
      component: ViewsDashboard,
      meta: { requiresRole: ['Login User', 'PBI Report 5'] }
    },
    {
      name: 'Monthly Export Dashboard', 
      path: '/monthly-export-dashboard',
      component: ViewsDashboard,
      meta: { requiresRole: ['Login User', 'PBI Report 6'] }
    },
    {
      name: 'Packaging Waste', 
      path: '/packaging-waste',
      component: ViewsDashboard,
      meta: { requiresRole: ['Login User', 'PBI Report 7'] }
    },
    {
      name: 'Daily Report - Paper', 
      path: '/daily-report-paper',
      component: ViewsDashboard,
      meta: { requiresRole: ['Login User', 'PBI Report 8'] }
    },
    {
      name: 'Daily Report - Plastic', 
      path: '/daily-report-plastic',
      component: ViewsDashboard,
      meta: { requiresRole: ['Login User', 'PBI Report 9'] }
    },
    {
      name: 'Market Trends', 
      path: '/market-trends',
      component: ViewsDashboard,
      meta: { requiresRole: ['Login User', 'PBI Report 10'] }
    },
    {
      name: 'Market Insights',
      path: '/insights-dashboard',
      component: ViewsDashboard,
      meta: { requiresRole: ['Login User', 'PBI Report 1'] }
    },
    {
      name: 'User',
      path: '/user',
      component: User,
      meta: { requiresRole: ['Login User'] }
    },
    {
      name: 'Recycling Ledger',
      path: '/recycling-ledger',
      component: RecyclingLedger,
      meta: { requiresRole: ['Ledger User'] }
    },
    {
      name: 'Users',
      path: '/users',
      component: Users,
      meta: { requiresRole: ['Admin'] }
    },
    {
      name: 'App Settings',
      path: '/app-settings',
      component: AppSettings,
      meta: { requiresRole: ['Admin']  }
    }
  ],
  meta: { requiresAuth: true }},
  {path: '/login', name: 'Login', component: Login},
  {path: '/signup', name: 'Signup', component: Signup},
  {path: '/forgot-password', name: 'Forgot Password', component: ForgotPassword},
  {path: '/reset-password', name: 'Reset Password', component: ResetPassword},
  {path: '/verify-email', name: 'Verify Email', component: VerifyEmail},
  {path: '*', redirect: '/'}
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const user = JSON.parse(localStorage.getItem('User'))

  if (to.matched.some(x=> x.meta.requiresAuth)) {
    if (!user) {
      next({path: '/login'})
    } else {
      if (to.path === '/') {      
        if (hasRole(user, 'Admin')) {
          next({path: '/users'})
        } else if (hasRole(user, 'Login User') && hasRole(user, 'PBI Report 4')) {
          next({path: '/prices-dashboard'})
        } else if (hasRole(user, 'Ledger User')) {
          next({path: '/my-business'})
        } else if (hasRole(user, 'PBI Report 1')) {
          next({path: '/insights-dashboard'})
        } else if (hasRole(user, 'PBI Report 2')) {
          next({path: '/collection-dashboard'})
        } else if (hasRole(user, 'PBI Report 3')) {
          next({path: '/forecast-dashboard'})
        } else if (hasRole(user, 'PBI Report 4')) {
          next({path: '/prices-dashboard'})
        } else if (hasRole(user, 'PBI Report 5')) {
          next({path: '/treatment-dashboard'})
        } else if (hasRole(user, 'PBI Report 6')) {
          next({path: '/monthly-export-dashboard'})
        } else if (hasRole(user, 'PBI Report 7')) {
          next({path: '/packaging-waste'})
        } else if (hasRole(user, 'PBI Report 8')) {
          next({path: '/daily-report-paper'})
        } else if (hasRole(user, 'PBI Report 9')) {
          next({path: '/daily-report-plastic'})
        } else if (hasRole(user, 'Login User')) {
          next({path: '/user'})
        } else {
          next(false)
        }
      } else {
          if (routes[0].children.find(x => x.path === to.path).meta.requiresRole.find(x => user.roles.data.map(y => y.name).includes(x))) {
            next()
          }
        else {
          next({path: '/'})
        }
      }
    }
  } else if ((to.path === '/login' || to.path === '/signup') && user) {
    next({path: '/'}) 
  } else {
    next()
  }
})

function hasRole(user, role) {
  return user.roles.data.map(x => x.name).includes(role)
}

export default router


